<div class="container my-5">
    <div class="row" *ngIf="!loading">
        <div class="col-md-12 text-right">
            <button type="button" class="btn btn-dark" (click)="back()">
                <i class="fa fa-angle-left" style="margin: 0 !important;"></i> <span
                    class="d-none d-lg-inline-block" style="margin-left: 0.5rem;">Retour</span>
            </button>
        </div>
        <div class="col-12">
            <h2 class="mb-4">Artiste</h2>
            <div class="card mb-4">
                <div class="card-header">
                    <h5 class="mb-0">Réservation en attente d'acceptation</h5>
                </div>
                <div class="card-body">
                    <p>Lorsque vous effectuez un paiement, l'argent est retenu par la plateforme Studiomap.</p>
                    <p>Vous serez intégralement remboursé si vous annulez avant que votre réservation ne soit acceptée.
                    </p>
                </div>
            </div>

            <div class="card mb-4">
                <div class="card-header">
                    <h5 class="mb-0">Annulation après acceptation</h5>
                </div>
                <div class="card-body">
                    <p>Si votre réservation est acceptée, vous pouvez toujours bénéficier d'un remboursement, sous
                        réserve d'annuler dans un délai spécifique déterminé par l'administration de Studiomap (par
                        exemple : <strong>{{ (nbr_hours_to_cancel_booking_before_start) ? nbr_hours_to_cancel_booking_before_start : "X" }}</strong> heures avant le début de la session).
                    </p>
                </div>
            </div>

            <div class="card mb-4">
                <div class="card-header">
                    <h5 class="mb-0">Absence de réponse du studio</h5>
                </div>
                <div class="card-body">
                    <p>Si le studio a accepté la réservation et ne répond pas à la date prévue, vous avez la possibilité
                        de contacter l'administration de Studiomap pour signaler le problème.</p>
                    <p>Cette demande doit être effectuée au moins <strong>{{ (nbr_hours_to_transfer_after_end_session) ? nbr_hours_to_transfer_after_end_session : "X" }}</strong> heures
                        après la fin de la période de réservation.
                    </p>
                </div>
            </div>
        </div>

        <div class="col-12">
            <h2 class="mb-4">Gérant</h2>
            <div class="card mb-4">
                <div class="card-header">
                    <h5 class="mb-0">Notifications et vérification</h5>
                </div>
                <div class="card-body">
                    <p>Lorsqu'un artiste réserve un studio, le gérant reçoit une notification pour accepter ou annuler
                        la réservation.</p>
                    <p>Si le studio annule, l'artiste sera remboursé.</p>
                    <p>Si le studio accepte, l'artiste reçoit une notification par email et par SMS.</p>
                    <p>Après <strong>{{ (nbr_hours_to_transfer_after_end_session) ? nbr_hours_to_transfer_after_end_session : "X" }}</strong> heures suivant la fin de la session, le studio reçoit son paiement si son compte est
                        vérifié.</p>
                    <p>Pour vérifier son compte, le gérant peut le faire depuis son profil en entrant son IBAN et en
                        cliquant sur le bouton <strong>"Vérifiez votre compte"</strong>.</p>
                </div>
            </div>
        </div>
    </div>
</div>